var map = {
	"./arup.png": 81799,
	"./astrazeneca.png": 88518,
	"./brightly.png": 79656,
	"./emperor.png": 72785,
	"./gph.png": 26814,
	"./greggs.png": 69204,
	"./howdens.png": 19507,
	"./lwc.png": 54559,
	"./menzies.png": 87642,
	"./miltton.png": 75232,
	"./pkf.png": 3666,
	"./plaut.png": 14223,
	"./pwc.png": 27115,
	"./rsk.png": 2225,
	"./subsea7.png": 94195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72246;